import type { StaticLayerPayload } from "@config";
import { ComboLibrary } from "@library-layers/combo";
import { Container } from "../Container";

export const Combo = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={{ default: ComboLibrary }} />
);
